export const hasActView = (columnNum) => {
    return ![1].includes(columnNum);
};
export const getFlashProductDisplayExtend = (isAct, columnNum = 2) => {
    if (isAct && hasActView(columnNum)) {
        return {
            showName: false,
            showPrice: false,
        };
    }
    return {
        showName: true,
        showPrice: true,
    };
};
export const isSoldOut = (soldout, columnNum) => {
    return soldout && hasActView(columnNum);
};
const formatTime = (t) => {
    if (t <= 0) {
        return "00";
    }
    return t > 9 ? `${t}` : `0${t}`;
};
export const formatSecToDate = (t) => {
    const hour = formatTime(Math.floor(t / 3600));
    const min = formatTime(Math.floor((t / 60) % 60));
    const sec = formatTime(Math.floor(t % 60));
    return `Ends in ${hour}:${min}:${sec}`;
};
